export const styles = {
    sizeWizard: {
        container: {
            border: "1px solid #E6E6E6",
            padding: "32px",
        },
        infoWrapper: {
            display: "inline-flex",
            alignItems: "center",
            gap: "8px",
            paddingTop: "1px",
            cursor: "pointer",
        },
        infoText: {
            fontWeight: 400,
            fontStyle: "normal",
            fontSize: "14px",
            lineHeight: "20px",
            letterSpacing: "0.6px",
            textDecoration: "underline",
            textDecorationThickness: "1px",
            textUnderlineOffset: "4px",
        },
        innerContainer: {
            display: "flex",
            gap: 2,
        },
        barWrapper: {
            flex: 1,
        },
        bar: {
            width: "100%",
            height: "2px",
        },
        text: {
            color: "#767676",
        },
    },
};
